import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { PlatformSettings } from "@/types";

// #235: Admin-Patch der Plattform-Settings (nur die gesendeten Keys ändern; Rest bleibt).
export function usePatchPlatformSettings(): UseMutationResult<
  PlatformSettings,
  Error,
  Partial<PlatformSettings>
> {
  const { session, logout } = useAuth();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch) => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.patch<PlatformSettings>("/platform-settings", patch);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.resource("platformSettings") }),
  });
}
